import Content from "@/components/Explore/Pubmed/Content";
import Hero from "@/components/Hero";
import { useNaviTrending } from "@/hooks/useNavi";
import {
  usePubmedAC,
  usePubmedSearch,
  usePubmedSearchHistory,
} from "@/hooks/usePubmed";
import useTranslation from "@/hooks/useTranslation";
import CommonLayout from "@/layouts/Common";
import { naviTrendingState } from "@/stores/navi";
import { NextPage } from "next";
import Head from "next/head";
import React from "react";
import { useRecoilValue } from "recoil";
import styles from "./styles.module.less";

const { wrapper, content } = styles;

interface IProps {
  page: number;
  size: number;
}

const Pubmed: NextPage<IProps> = (props) => {
  usePubmedSearchHistory();
  const { loading: loadingSearch, handleSearch } = usePubmedSearch();
  const { suggestTerms, suggestedTerms } = usePubmedAC();
  const { t } = useTranslation("explore");
  const { loading: loadingTrending, changePage } = useNaviTrending(props);
  const papers = useRecoilValue(naviTrendingState);

  const contentProps = {
    term: "trending[sb]",
    fetchResults: papers,
    count: 1000,
    loadingFetch: loadingTrending,
    loadingSearch: papers?.length === 0 && loadingTrending,
    locationInfo: props,
    handleFetch: changePage,
  };

  const bannerProps = {
    term: "",
    title: t("pubmed.banner.title"),
    slogan: t("pubmed.banner.slogan"),
    placeholder: t("pubmed.banner.placeholder"),
    statement: t("pubmed.banner.statement"),
    acOptions: suggestedTerms,
    handleSearch,
    loadingSearch,
    handleChange: suggestTerms,
  };

  return (
    <CommonLayout>
      <Head>
        <title>
          {t("menu:explore.pubmed")} - {t("menu:explore.itself")} - MedicGo
        </title>
      </Head>
      <div className={wrapper}>
        <Hero {...bannerProps} />
        <div className={content}>
          <Content {...contentProps} />
        </div>
      </div>
    </CommonLayout>
  );
};

Pubmed.getInitialProps = async (ctx) => {
  const page = parseInt((ctx.query.page as string) || "1", 10);
  const size = parseInt((ctx.query.size as string) || "10", 10);
  return {
    page,
    size,
    namespacesRequired: ["explore", "common", "menu"],
  };
};

export default Pubmed;
